import React from "react";

const EventReportContext = React.createContext({});

export default EventReportContext;
